import * as React from 'react';
import {
    MessageBar,
    MessageBarType,
    PrimaryButton,
    Spinner,
    SpinnerSize,
    Stack,
    Text,
} from '@fluentui/react';

export interface DefinitionCatalogItem {
    name: string;
    disabled: boolean;
    subtitle: string;
}

interface DefinitionCatalogProps {
    sectionMetadata: { text: string; description: string };
    currentSectionItems: DefinitionCatalogItem[];
    mode: 'create' | 'edit';
    selectedName: string;
    catalogLoading: boolean;
    onSelectItem: (name: string) => void;
    onCreate: () => void;
}

export function DefinitionCatalog(props: DefinitionCatalogProps) {
    const {
        sectionMetadata,
        currentSectionItems,
        mode,
        selectedName,
        catalogLoading,
        onSelectItem,
        onCreate,
    } = props;

    return (
        <div
            style={{
                width: 320,
                minWidth: 320,
                border: '1px solid #e1dfdd',
                borderRadius: 8,
                padding: 16,
                background: '#ffffff',
            }}
        >
            <Stack tokens={{ childrenGap: 12 }}>
                <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
                    <Text variant="large">{sectionMetadata.text}</Text>
                    <PrimaryButton text="Create new" onClick={onCreate} />
                </Stack>
                <Text styles={{ root: { color: '#605e5c' } }}>{sectionMetadata.description}</Text>

                {catalogLoading ? (
                    <Spinner size={SpinnerSize.medium} label="Loading definitions..." />
                ) : currentSectionItems.length === 0 ? (
                    <MessageBar messageBarType={MessageBarType.info}>
                        No {sectionMetadata.text.toLowerCase()} exist for this service yet.
                    </MessageBar>
                ) : (
                    <Stack tokens={{ childrenGap: 8 }}>
                        {currentSectionItems.map(item => {
                            const isSelected = mode !== 'create' && item.name === selectedName;
                            return (
                                <button
                                    key={item.name}
                                    type="button"
                                    onClick={() => onSelectItem(item.name)}
                                    style={{
                                        border: isSelected ? '1px solid #0078d4' : '1px solid #e1dfdd',
                                        borderRadius: 6,
                                        padding: 12,
                                        background: isSelected ? '#eff6fc' : '#ffffff',
                                        textAlign: 'left',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <div style={{ fontWeight: 600 }}>{item.name}</div>
                                    <div style={{ color: '#605e5c', marginTop: 4 }}>{item.subtitle}</div>
                                    {item.disabled && (
                                        <div style={{ color: '#a4262c', marginTop: 4 }}>Disabled</div>
                                    )}
                                </button>
                            );
                        })}
                    </Stack>
                )}
            </Stack>
        </div>
    );
}
